var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKatalog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 3C13.6046 3 14.5 3.89543 14.5 5L14.5 19C14.5 20.1046 13.6046 21 12.5 21C11.3954 21 10.5 20.1046 10.5 19L10.5 5C10.5 3.89543 11.3954 3 12.5 3ZM4.5 12C5.60457 12 6.5 12.8954 6.5 14V19C6.5 20.1046 5.60457 21 4.5 21C3.39543 21 2.5 20.1046 2.5 19V14C2.5 12.8954 3.39543 12 4.5 12ZM22.5 10C22.5 8.89543 21.6046 8 20.5 8C19.3954 8 18.5 8.89543 18.5 10V19C18.5 20.1046 19.3954 21 20.5 21C21.6046 21 22.5 20.1046 22.5 19V10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKatalog);
export default __webpack_public_path__ + "static/media/katalog.35312d752ea25703929705ade321865a.svg";
export { ForwardRef as ReactComponent };